import Config from "../../utils/Config";
import axios from "axios";
const BASE_URL = Config.baseUrl;

class RegisterRequest {
  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }
//commmentttttt
  async registerUser(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}api/user/register`,
        payload,
        { headers: this.headers }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      // console.log("Registration error:", error?.response?.data?.data);
      return {
        success: false,
        error: error?.response?.data?.data?.reason || "Sorry, an error occurred during registration.",
        validationErrors: error?.response?.data?.data?.errors || null,
        status: error.response?.status || 500,
      };
    }
  }

  async verifyOtp(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}api/user/verify/account`,
        payload,
        { headers: this.headers }
      );
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }

  async resendVerification(payload) {
    try {
      const response = await axios.post(
        `${BASE_URL}api/user/resend/verificationCode`,
        payload,
        { headers: this.headers }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

const registerRequest = new RegisterRequest();
export default registerRequest;
